export default "__VITE_PUBLIC_ASSET__d8182153__"